import { Link } from "react-router-dom";
import { getAllPosts, formatBlogDate } from "../lib/blog";
import { Card } from "../components/ui/Card";
import { useSeoMeta, SITE_URL, SITE_NAME, PUBLISHER_NAME } from "../lib/seo";

const DESCRIPTION =
  "Practical, accurate guides on Bitcoin wallet recovery, BIP-39 seed phrases, transaction tracing, and what to do after a crypto scam — no guaranteed-recovery claims, no fabricated case studies.";

export default function BlogIndex() {
  const posts = getAllPosts();

  useSeoMeta({
    title: "Blog",
    description: DESCRIPTION,
    path: "/blog",
    jsonLd: {
      "@context": "https://schema.org",
      "@type": "Blog",
      name: `${SITE_NAME} Blog`,
      description: DESCRIPTION,
      url: `${SITE_URL}/blog`,
      publisher: { "@type": "Organization", name: PUBLISHER_NAME, url: SITE_URL },
      blogPost: posts.map((post) => ({
        "@type": "BlogPosting",
        headline: post.title,
        url: `${SITE_URL}/blog/${post.slug}`,
        datePublished: post.date,
      })),
    },
  });

  return (
    <div className="max-w-4xl mx-auto px-6 py-16">
      <h1 className="font-display text-3xl mb-2">Blog</h1>
      <p className="text-muted mb-10">{DESCRIPTION}</p>

      <div className="grid gap-4">
        {posts.map((post) => (
          <Card key={post.slug} as={Link} to={`/blog/${post.slug}`} padding="lg" interactive className="block">
            <p className="text-xs text-muted font-mono">{formatBlogDate(post.date)}</p>
            <h2 className="mt-1 font-display text-xl">{post.title}</h2>
            <p className="mt-2 text-sm text-muted">{post.description}</p>
            <span className="mt-3 inline-block text-sm text-ledger-400">Read more →</span>
          </Card>
        ))}
      </div>
    </div>
  );
}
